<sky-ui-popup>
  <ng-container skyUiPopupTitle>{{ title }}</ng-container>

  <div skyUiPopupBody class="popup-body" [innerHTML]="message"></div>

  <sky-ui-button
    *ngIf="behaviour === 'confirm'"
    color="brand"
    skyUiPopupAcceptButton
    (click)="confirm()"
  >
    {{ confirmText || 'Confirm' }}
  </sky-ui-button>
  <sky-ui-button
    *ngIf="behaviour === 'confirm'"
    skyUiPopupDeclineButton
    type="secondary"
    (click)="cancel()"
  >
    {{ cancelText || 'Cancel' }}
  </sky-ui-button>

  <sky-ui-button
    *ngIf="behaviour === 'alert'"
    color="brand"
    skyUiPopupDeclineButton
    (click)="confirm()"
  >
    {{ cancelText || 'Ok' }}
  </sky-ui-button>
</sky-ui-popup>
